const KEY = "cookie-consent";
const EVT = "consent-updated";

export const getConsent = () => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const needsConsentChoice = () => {
  const c = getConsent();
  return !c || typeof c.marketing !== "boolean";
};

export const hasMarketingConsent = () => {
  const c = getConsent();
  return !!(c && c.marketing);
};

export const setConsent = (marketing) => {
  localStorage.setItem(KEY, JSON.stringify({ accepted: true, marketing, date: new Date().toISOString() }));
  window.dispatchEvent(new CustomEvent(EVT, { detail: { marketing } }));
};

export const onConsentChange = (cb) => {
  const handler = (e) => cb(e.detail);
  window.addEventListener(EVT, handler);
  return () => window.removeEventListener(EVT, handler);
};

const OPEN_EVT = "open-cookie-preferences";

export const openCookiePreferences = () => {
  window.dispatchEvent(new CustomEvent(OPEN_EVT));
};

export const onOpenPreferences = (cb) => {
  window.addEventListener(OPEN_EVT, cb);
  return () => window.removeEventListener(OPEN_EVT, cb);
};

export const trackPixel = (event, params) => {
  if (!hasMarketingConsent()) return;
  let tries = 0;
  const attempt = () => {
    if (window.fbq) {
      window.fbq("track", event, params);
    } else if (tries++ < 20) {
      setTimeout(attempt, 200);
    }
  };
  attempt();
};

export const trackGA = (event, params) => {
  if (!hasMarketingConsent()) return;
  let tries = 0;
  const attempt = () => {
    if (window.gtag) {
      window.gtag("event", event, params || {});
    } else if (tries++ < 20) {
      setTimeout(attempt, 200);
    }
  };
  attempt();
};

let _adsCfg = null;
let _adsCfgPromise = null;
const loadAdsConfig = () => {
  if (_adsCfg) return Promise.resolve(_adsCfg);
  if (!_adsCfgPromise) {
    _adsCfgPromise = fetch(`${process.env.REACT_APP_BACKEND_URL}/api/config/public`)
      .then((r) => r.json())
      .then((d) => { _adsCfg = d; return d; })
      .catch(() => ({}));
  }
  return _adsCfgPromise;
};

export const trackAdsConversion = (labelKey) => {
  if (!hasMarketingConsent()) return;
  loadAdsConfig().then((cfg) => {
    const id = cfg && cfg.gads_conversion_id;
    const label = cfg && cfg[labelKey];
    if (!id || !label) return;
    let tries = 0;
    const attempt = () => {
      if (window.gtag) {
        window.gtag("config", id);
        window.gtag("event", "conversion", { send_to: `${id}/${label}` });
      } else if (tries++ < 20) {
        setTimeout(attempt, 200);
      }
    };
    attempt();
  });
};
